import { atom } from 'recoil';
import { IBU } from '../../../commons/types/config';

export const buAtom = atom<IBU[]>({
  key: 'bu',
  default: [] as IBU[],
});
